/**
 * OperationsLayout
 * Single entry point for Partners, Drivers, and Products
 */

import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Tab } from "@mui/material";
import { People, DirectionsCar, Inventory } from "@mui/icons-material";
import {
  PageShell,
  PageHeader,
  PageTabs,
} from "../../../shared/components/pageShell";

const tabForPath = (pathname) => {
  if (pathname.includes("/operations/partners")) return 0;
  if (pathname.includes("/operations/drivers")) return 1;
  if (pathname.includes("/operations/products")) return 2;
  return 0;
};

export default function OperationsLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const tab = tabForPath(location.pathname);

  const handleTabChange = (_, newValue) => {
    if (newValue === 0) navigate("/operations/partners");
    if (newValue === 1) navigate("/operations/drivers");
    if (newValue === 2) navigate("/operations/products");
  };

  return (
    <PageShell>
      <PageHeader
        title="Operations"
        subtitle="Partners, drivers, and products — one place."
      />

      <PageTabs value={tab} onChange={handleTabChange}>
        <Tab
          icon={<People />}
          iconPosition="start"
          label="Partners"
          sx={{ textTransform: "none" }}
        />
        <Tab
          icon={<DirectionsCar />}
          iconPosition="start"
          label="Drivers"
          sx={{ textTransform: "none" }}
        />
        <Tab
          icon={<Inventory />}
          iconPosition="start"
          label="Products"
          sx={{ textTransform: "none" }}
        />
      </PageTabs>

      <Outlet />
    </PageShell>
  );
}
